<section
  aria-label="Messages"
  aria-live="polite"
  aria-relevant="additions"
  class="min-h-0 max-w-3xl w-full flex flex-1 flex-col"
>
  <main
    #chatContainer
    class="flex-1 p-4 md:p-6 mib-scrollbar flex flex-col gap-4 overflow-y-auto min-h-0"
    [class.justify-center]="!hasMessages()"
  >
    @if (!hasMessages()) {
      <!-- Empty state: welcome the user and suggest example prompts -->
      <div class="flex flex-col gap-4 self-center w-full max-w-80">
        <mai-mib-logo
          class="self-center [@media(max-height:730px)]:hidden"
          theme="dark"
          size="xl"
        ></mai-mib-logo>
        <div class="flex flex-col gap-2">
          <h2 class="text-xl font-normal leading-7 text-branding-50">
            Hi, I'm Medinbox AI Assistant.
          </h2>
          <p class="text-xs font-normal leading-4.5 text-branding-50">
            I'm watching this case with you.<br />
            Ask me anything about what you're seeing.
          </p>
          <div class="text-xs font-normal leading-4.5 text-branding-50">
            <p>For example:</p>
            <ul class="pl-2">
              <li>- Summarize the case so far</li>
              <li>- Explain the strategy</li>
              <li>- Walk me through the alternatives</li>
              <li>- Give me the key teaching point</li>
            </ul>
          </div>
        </div>
      </div>
    }
    @for (entry of messages(); track entry.message.id) {
      <div
        class="flex flex-col gap-px"
        [class.items-end]="entry.senderIdentity === localIdentity()"
        [class.text-right]="entry.senderIdentity === localIdentity()"
      >
        <div
          class="markdown-message w-fit rounded-l-2xl rounded-br-2xl rounded-tr-sm"
          [class.p-4]="entry.senderIdentity === localIdentity()"
          [class.bg-branding-800]="entry.senderIdentity === localIdentity()"
          [innerHTML]="entry.message.message | markdown"
        ></div>
      </div>
    }
    @if (isThinking()) {
      <mai-chatia-thinking isThinking></mai-chatia-thinking>
    }
    <div aria-hidden="true" class="shrink-0" [style.height.px]="chatSpacerHeight()"></div>
  </main>
  <div class="shrink-0 p-4 border-branding-500 max-lg:landscape:p-2 flex flex-col gap-4">
    <mai-prompt-box
      [hidePTT]="hidePtt()"
      [isPttActive]="isPttActive()"
      [pttTranscription]="pttTranscription()"
      (messageSent)="sendMessage($event)"
      (pttStart)="onPttStart()"
      (pttStop)="onPttStop()"
    ></mai-prompt-box>
    @if (hasMessages()) {
      <!-- Short disclaimer once the conversation has started -->
      <p
        class="font-sans text-xs font-normal leading-4.5 text-branding-300 text-center wrap-break-word px-7"
      >
        Educational only. Not medical advice.<br />
        AI can make mistakes. The physician decides.
      </p>
    } @else {
      <!-- Full disclaimer on the empty state (narrower than the input, per Figma) -->
      <div
        class="font-sans text-xs font-normal leading-4.5 text-branding-300 wrap-break-word flex flex-col gap-4.5 px-7"
      >
        <p>
          Medinbox AI Assistant. In accordance with ACCME Standard 1.3, new and evolving topics. For
          educational use only. Responses are informational, not medical advice.
        </p>
        <p>
          AI systems can make mistakes. Final responsibility for clinical decisions always rests with
          the human professional. A new and evolving educational tool, presented for discussion.
        </p>
      </div>
    }
  </div>
  @if (!hasMessages()) {
    <!-- Copyright + legal popup link, only on the empty state -->
    <mai-copyright-and-legal-link
      class="shrink-0 py-4 text-center text-xs! font-light text-branding-400"
    ></mai-copyright-and-legal-link>
  }
</section>
